
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testing",
      function () {
        return require("private-next-pages/testing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testing"])
      });
    }
  